const isActive = (elem) => elem.classList.contains('share--active');
const getClickedIcon = (elem) => [...elem.classList].filter(x => x.includes('share__link--')).pop().split('--').pop()
const openShareLink = (clickedIcon) => {
    let shareLink;

    switch (clickedIcon) {
        case 'facebook':
            shareLink = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href;
            break;
        case 'twitter':
            shareLink = 'https://twitter.com/intent/tweet?text=' + document.title + '&url=' + window.location.href;
            break;
        case 'linkedin':
            shareLink = 'https://www.linkedin.com/sharing/share-offsite/?url=' + document.title + '&url=' + window.location.href;
            break;
        case 'mail':
            shareLink = 'mailto:?subject=' + document.title + '&body=' + window.location.href;
            break;
    }
    if (clickedIcon !== 'mail') {
        window.open(shareLink, '_blank', 'width=600,height=400');
    } else {
        window.location.href = shareLink;
    }
}

const closeShareContainer = (shareContainer) => {
    shareContainer.classList.remove('share--active');
}

const init = () => {
    const shareIcons = [...document.querySelectorAll('.share__link')];
    const shareContainer = document.querySelector('.share');
    if (!shareContainer) return;

    shareContainer.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation()
        if (isActive(shareContainer)) {
            shareContainer.classList.remove('share--active');
        } else {
            shareContainer.classList.add('share--active');
        }
    });

    for (const shareIcon of shareIcons) {
        shareIcon.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation()
            if (!isActive(shareContainer)) return;
            const clickedIcon = getClickedIcon(shareIcon);
            closeShareContainer(shareContainer);
            openShareLink(clickedIcon);
        });
    }
}

document.addEventListener('DOMContentLoaded', init);
